"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const join = (rules) => (fieldValue, formValues, props) => (0, lodash_1.default)(rules)
    .filter(lodash_1.default.isFunction)
    .map((rule) => rule(fieldValue, formValues, props))
    .compact()
    .head();
const createValidator = (schema, rulesType = 'error') => (formValues = {}, props = {}) => {
    const messages = {};
    (0, lodash_1.default)(schema)
        .keys()
        .forEach((fieldName) => {
        function processRules(ruleSet) {
            const rule = join([].concat(ruleSet)); // concat enables both functions and arrays of functions
            // The result of running the joined rule function will either be:
            // - string: an error
            // - array of functions: more validations to run
            // - undefined: indicating no error
            const ruleResult = rule(formValues[fieldName], formValues, props);
            if (ruleResult) {
                if (lodash_1.default.isArray(ruleResult)) {
                    processRules(ruleResult);
                }
                else {
                    messages[fieldName] = ruleResult;
                }
            }
        }
        const rulesKey = rulesType === 'error' ? 'validation' : 'warnings';
        const rules = lodash_1.default.isArray(schema[fieldName]) && rulesType === 'error' ? schema[fieldName] : schema[fieldName][rulesKey];
        processRules(rules);
    });
    return messages;
};
exports.default = createValidator;
